import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import componentsService from "./componentService"


const initialState = {
    components: [],
    allComponents: [],


    isError: false,
    isAllComponentsError: false,


    isSuccess: false,
    isLoading: false,
    isAllComponentsLoading: false,

    message: "",
    allComponentsMessage: "",
}



export const getComponents = createAsyncThunk("component/user/all", async (clinicId: string, thunkAPI) => {
    try {
        return await componentsService.getComponents(clinicId)
    } catch (error: any) {
        const message =
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
            error.message ||
            error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getAllComponents = createAsyncThunk("component/all", async (_, thunkAPI) => {
    try {
        return await componentsService.getAllComponents()
    } catch (error: any) {
        const message =
            (error.response &&
                error.response.data &&
                error.response.data.message) ||
            error.message ||
            error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})


export const componentsSlice = createSlice({
    name: "components",
    initialState,
    reducers: {
        reset: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getComponents.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getComponents.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.components = action.payload
                state.message = ""

            })
            .addCase(getComponents.rejected, (state, action: PayloadAction<any>) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getAllComponents.pending, (state) => {
                state.isAllComponentsLoading = true
            })
            .addCase(getAllComponents.fulfilled, (state, action) => {
                state.isAllComponentsLoading = false
                state.isSuccess = true
                state.allComponents = action.payload
                state.allComponentsMessage = ""

            })
            .addCase(getAllComponents.rejected, (state, action: PayloadAction<any>) => {
                state.isAllComponentsLoading = false
                state.isAllComponentsError = true
                state.allComponentsMessage = action.payload
            })
    }
})

export const { reset } = componentsSlice.actions
export default componentsSlice.reducer